<div class="content">
    <div id="talkjs-container" style="height: 500px"> <mat-spinner [diameter]="30" [strokeWidth]="3" mode="indeterminate" style="margin: auto;"></mat-spinner></div>

</div>

